<template>
  <div class="form-group">
    <span v-if="allowOpen" class="openIcon" v-on:click="openAnmeldung"
      ><font-awesome-icon icon="fa-duotone fa-arrow-circle-right"
    /></span>
    <input v-model="anmeldung.id" type="hidden" />
    <b-form-input v-model="anmeldungTitel" readonly placeholder=" " />
    <label>{{ label }}</label>
  </div>
</template>
  
  <script>
import { v4 as uuid } from "uuid";

export default {
  name: "RedirectAnmeldung",
  components: {},
  props: {
    id: {
      type: String,
      default: uuid(),
    },
    anmeldung: {
      type: Object,
      required: false,
      default: function () {
        return { anmeldungTitel: this.$t("global.notlinked") };
      },
    },
    allowOpen: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    anmeldungTitel: function () {
      if (!this.anmeldung || !this.anmeldung.id)
        return this.$t("global.notlinked");

      return this.anmeldung
        ? this.anmeldung.vorname + " " + this.anmeldung.nachname
        : "";
    },
  },
  mounted: function () {},
  methods: {
    openAnmeldung() {
      if (this.anmeldung.id) {
        this.$router.push({
          name: "anmeldung",
          params: { anmeldungid: this.anmeldung.id, anzeige: 0 },
        });
      }
    },
  },
};
</script>
  